module.exports = __webpack_public_path__ + "img/icon-wordpress.svg";